import { atom } from 'recoil';

import { defaultParams, initialSelectedOption } from '../constants';
import { StatementsFilterParamsProps } from '../types';

export const statementOptionQueryState = atom({
  key: 'statementOptionQueryState',
  default: initialSelectedOption,
});

export const statementsFilterParamsState = atom({
  key: 'statementsFilterParamsState',
  default: { ...defaultParams } as StatementsFilterParamsProps,
});

export const isExportingPdfForStatements = atom({
  key: 'isExportingPdfForStatements',
  default: false,
});
